<template>
  <div
    :class="
      customers.length > 0
        ? `container bg-deep-purple-1`
        : `container-no-customer bg-deep-purple-1`
    "
  >
    <q-btn-group unelevated class="q-ma-xs full-width">
      <q-btn
        class="col-grow"
        dense
        no-caps
        no-wrap
        color="white"
        text-color="primary"
        label="Add Customer"
        icon="add"
        @click="addCustomerDialog.show = true"
      />
      <q-btn
        class="col-grow"
        dense
        no-caps
        no-wrap
        color="white"
        text-color="primary"
        label="View all"
        @click="allCustomerShow = true"
      />
      <q-btn
        v-if="isAdmin"
        dense
        no-caps
        no-wrap
        color="white"
        text-color="primary"
        icon="poll"
        label="Stat"
        @click="onStat"
      />
      <q-btn
        v-if="isAdmin"
        dense
        no-caps
        no-wrap
        color="white"
        text-color="primary"
        icon="summarize"
        label="Report"
        @click="onReport"
      />
      <q-btn
        v-if="isAdmin"
        dense
        no-caps
        no-wrap
        color="white"
        text-color="primary"
        icon="qr_code_scanner"
        label="Scan"
        @click="onScan"
      />
    </q-btn-group>
    <q-scroll-area
      v-if="customers.length > 0"
      horizontal
      :thumb-style="thumbStyle"
      :bar-style="barStyle"
      class="customer-list"
    >
      <div class="row no-wrap">
        <q-card
          :flat="customer.id === activeCustomerID"
          v-for="(customer, index) in customers"
          :key="index"
          :class="
            customer.id === activeCustomerID
              ? `my-card-active q-ma-xs`
              : `my-card q-ma-xs`
          "
          @click="onSelectCustomer(customer)"
        >
          <q-item dense>
            <q-item-section avatar>
              <q-avatar size="md" color="primary" text-color="white">{{
                customer.firstname.charAt(0).toUpperCase()
              }}</q-avatar>
            </q-item-section>

            <q-item-section no-wrap>
              <q-item-label class="text-primary">{{
                customer.firstname
              }}</q-item-label>
              <!-- <q-item-label caption>Subhead</q-item-label> -->
              <q-item-label caption>{{ customer.phone_number }}</q-item-label>
            </q-item-section>
            <!-- 
                        <q-item-section avatar>
                            <q-btn
                                unelevated
                                size="sm"
                                color="primary"
                                text-color="white"
                                @click="onView(customer)"
                            >
                                View
                            </q-btn>
                        </q-item-section> -->
          </q-item>
        </q-card>
      </div>
    </q-scroll-area>
    <q-dialog v-model="addCustomerDialog.show" persistent>
      <AddCustomerDialog
        @addCustomerWithForm="onAddCustomerWithForm"
        @confirmAddCustomer="onConfirmAddCustomer($event)"
      />
    </q-dialog>
    <q-dialog
      v-model="allCustomerShow"
      persistent
      :maximized="true"
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <FullScreenDialog>
        <all-customer-dialog
          @choosed-customer="onSelectCustomer($event)"
        ></all-customer-dialog>
      </FullScreenDialog>
    </q-dialog>
  </div>
</template>

<script>
import Auth from "@aws-amplify/auth";
import { mapState } from "vuex";
import { QDialog } from "quasar";
const components = { QDialog };

export default {
  name: "CustomersBar",
  components: {
    ...components,
    AddCustomerDialog: () => import("@/ui/components/AddCustomerDialog.vue"),
    FullScreenDialog: () => import("@/ui/components/FullScreenDialog.vue"),
    AllCustomerDialog: () => import("@/ui/components/AllCustomerDialog.vue"),
  },
  data() {
    return {
      isAdmin: false,
      thumbStyle: {
        borderRadius: "1.5px",
        backgroundColor: "#282669",
        height: "3px",
        opacity: 1,
      },
      barStyle: {
        right: "2px",
        borderRadius: "9px",
        backgroundColor: "#027be3",
        width: "9px",
        opacity: 0,
      },
      addCustomerDialog: {
        show: false,
      },
      allCustomerShow: false,
    };
  },
  computed: {
    ...mapState({
      customers: (state) => state["sale"]["customers"],
      activeCustomerID: (state) => state["activeCustomer"]["customer"]["id"],
    }),
  },
  async mounted() {
    const user = await Auth.currentAuthenticatedUser();
    if (user) {
      const session = await Auth.currentSession();
      const groups = session.getIdToken().payload["cognito:groups"];
      console.log({ groups });
      if (groups.includes("Admin")) {
        this.isAdmin = true;
        // console.log("admin check: ", this.isAdmin);
        return;
      }
      this.isAdmin = false;
    }
  },
  methods: {
    onAddCustomerWithForm() {
      this.addCustomerDialog.show = false;
    },
    onSelectCustomer(customer) {
      console.log("onSelectCustomer", customer);
      this.$store.commit("activeCustomer/setCustomer", customer);
      this.allCustomerShow = false;
    },
    onScan() {
      this.$router.push({
        name: "Scan",
      });
    },
    // onView(customer){
    //     this.$router.push({
    //         name: "Cart"
    //     })
    // }
    onConfirmAddCustomer(customer) {
      console.log("onConfirmAddCustomer:", customer);
      this.addCustomerDialog.show = false;
    },
    onStat() {
      console.log("onStat");
      this.$router.push({
        name: "SaleStat",
      });
    },
    onReport(){
      console.log("onReport");
      this.$router.push({
        name: "Report",
      })
    }
  },
};
</script>

<style scoped>

.container {
  height: 95px;
}
.container-no-customer {
  height: 50px;
}
.customer-list {
  /* border: 1px solid red; */
  height: 55px;
}
.my-card {
  min-width: 200px;
}
.my-card-active {
  min-width: 200px;
  border: 3px solid #8bc34a;
}

</style>
